import { create } from 'zustand';

const useAchievementStore = create(set => ({
    queue: [],
    enqueue: achievement => set(state => state.queue.some(item => item.id === achievement.id)
        ? state : { queue: [...state.queue, achievement] }),
    remove: id => set(state => ({ queue: state.queue.filter(item => item.id !== id) })),
    clearScope: scope => set(state => ({ queue: state.queue.filter(item => item.scope !== scope) })),
}));

export default useAchievementStore;
